import { useNow } from '../hooks/useNow';
import { formatDateTime, formatRelative } from '../lib/format';

/** "3 minutes ago" with the absolute time as tooltip; re-renders periodically. */
export function RelativeTime({ value, fallback = 'never', className = '' }: { value: string | null | undefined; fallback?: string; className?: string }) {
  const now = useNow();
  if (!value) return <span className={`text-base-content/60 ${className}`}>{fallback}</span>;
  return (
    <time dateTime={value} title={formatDateTime(value)} className={className}>
      {formatRelative(value, now)}
    </time>
  );
}
